import UserFriendlyIcon from '../price/user-friendly'

export default UserFriendlyIcon
